// extracted by mini-css-extract-plugin
module.exports = {"priceForm":"styles_priceForm__Sa2Rj","container":"styles_container__3H3Br","spinner":"styles_spinner__1m93i","submitButton":"styles_submitButton__2vXJE"};